import React from "react"
import styled from "styled-components"
import { StaticImage } from "gatsby-plugin-image"

import { Container, Row, Col } from "../Grid"
import Snippet from "../Snippet"

import { media, mixins } from "../../styles"

import IconWithText from "../IconWithText"

const Wrapper = styled.div`
  h2 {
    ${mixins.title3}
    text-align: center;
    margin-bottom: 30px;

    @media ${media.md} {
      margin-bottom: 50px;
    }

    @media ${media.xl} {
      margin-bottom: 100px;
    }
  }
`

const Illustration = styled.div`
  margin: 0 auto 60px;
  max-width: 420px;

  img {
    height: auto;
    max-width: 100%;
  }

  @media ${media.xl} {
    padding: 0 40px;
    align-items: center;
    display: flex;
    height: 100%;
    margin-bottom: 0;
    max-width: 100%;
  }
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;

  @media ${media.md} {
    flex-flow: row wrap;
    gap: 10px 40px;
    justify-content: flex-start;

    .icon-with-text {
      flex: 0 0 calc(50% - 20px);
      width: calc(50% - 20px);
    }
  }

  @media ${media.xl} {
    flex-direction: column nowrap;
    gap: 0;

    .icon-with-text {
      flex: auto;
      width: 100%;
    }
  }

  .icon-with-text:last-child {
    margin-bottom: 0;
  }
`

const Benefits = ({ benefits }) => {
  return (
    <Wrapper>
      <Container>
        <Row>
          <Col sm="8" smOffset="2" xl="6" xlOffset="3">
            <h2>
              <Snippet id="homeBenefits" field="header" />
            </h2>
          </Col>
        </Row>
        <Row>
          <Col xl="6">
            <Illustration>
              <StaticImage
                src="../../images/content/home/benefits-why.png"
                alt={Snippet({ id: "homeBenefits", field: "header" })}
                layout="constrained"
                height={433}
                width={611}
              />
            </Illustration>
          </Col>
          <Col xl="5">
            <Content>
              {benefits.map((benefit, i) => (
                <IconWithText
                  title={benefit.title}
                  text={benefit.description?.childMarkdownRemark?.html}
                  icon={benefit.icon}
                  key={i}
                  layout="icon-left"
                />
              ))}
            </Content>
          </Col>
        </Row>
      </Container>
    </Wrapper>
  )
}

export default Benefits
